import { AppState } from '../../root-reducer';

export const selectSubdomainTileLayers = (state: AppState) => state.subdomainTileLayerDomain.tileLayers;

export const selectActiveSubdomainTileLayer = (state: AppState) => state.subdomainTileLayerDomain.activeTileLayer;
